var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "" } },
        [
          _c("v-toolbar-title", { staticClass: "text-uppercase" }, [
            _vm._v(
              "Customer Forecast - " + _vm._s(_vm.customerData.company || null)
            )
          ]),
          !_vm.customerData.company
            ? _c("v-progress-circular", {
                staticClass: "ml-2",
                attrs: { indeterminate: "", size: "20" }
              })
            : _vm._e()
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          dense: "",
          "single-expand": "",
          items: _vm.cxFcstList,
          "show-expand": "",
          loading: _vm.cxFcstGetting
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "px-1" },
                    [
                      _c(
                        "base-tooltip",
                        {
                          attrs: {
                            text: "",
                            color: "yellow darken-3",
                            "x-small": "",
                            tooltip: "edit"
                          },
                          on: {
                            click: function($event) {
                              return _vm.editItem(item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c("td", { staticClass: "px-1" }, [
                    _c("span", [_vm._v(_vm._s(item.quantity))])
                  ]),
                  _c("td", { staticClass: "px-1" }, [
                    _c("span", { staticClass: "grey--text" }, [
                      _vm._v(
                        _vm._s((item.stock_category || {}).name || "N / A")
                      )
                    ]),
                    (item.stock_category || {}).sow_pig_cycle_preference &&
                    !(item.sow_pig || {}).piglets
                      ? _c("span", { staticClass: "primary--text" }, [
                          _vm._v(
                            " " +
                              _vm._s((item.sow_pig || {}).sow_number || null)
                          )
                        ])
                      : _vm._e(),
                    (item.stock_category || {}).sow_pig_cycle_preference &&
                    !(item.sow_pig || {}).piglets
                      ? _c("span", { staticClass: "success--text" }, [
                          _vm._v(
                            " " + _vm._s(_vm.farrowingStatus(item.sow_pig))
                          )
                        ])
                      : _vm._e(),
                    (item.stock_category || {}).sow_pig_cycle_preference &&
                    !(item.sow_pig || {}).piglets
                      ? _c("span", { staticClass: "error--text" }, [
                          _vm._v(" " + _vm._s(_vm.farrowingDays(item.sow_pig)))
                        ])
                      : _vm._e(),
                    (item.sow_pig || {}).piglets
                      ? _c(
                          "span",
                          { staticClass: "orange--text text--darken-2" },
                          [
                            _vm._v(
                              " " +
                                _vm._s((item.sow_pig || {}).piglets || 0) +
                                " piglet(s)"
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _c("td", { staticClass: "px-1" }, [
                    _vm._v(_vm._s(item.days))
                  ]),
                  _c("td", { staticClass: "px-1" }, [
                    _vm._v(_vm._s((item.date_confirmed || "").dateFormat()))
                  ]),
                  _c(
                    "td",
                    { staticClass: "px-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "pa-0 ma-0",
                          class: isExpanded ? "is-expanded" : "",
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "blue-grey"
                          },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-down")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item, headers }) {
              return [
                _c(
                  "td",
                  { attrs: { colspan: headers.length } },
                  [
                    _c(
                      "v-row",
                      {
                        staticClass: "ma-0 border-bottom",
                        attrs: { transition: "slide-y-transition" }
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 py-2",
                            attrs: { cols: "3", align: "center" }
                          },
                          [
                            _c("small", { staticClass: "blue-grey--text" }, [
                              _vm._v("Stock")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 py-2",
                            attrs: { cols: "3", align: "center" }
                          },
                          [
                            _c("small", { staticClass: "blue-grey--text" }, [
                              _vm._v("Type")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 py-2",
                            attrs: { cols: "3", align: "center" }
                          },
                          [
                            _c("small", { staticClass: "blue-grey--text" }, [
                              _vm._v("Date Start")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 py-2",
                            attrs: { cols: "3", align: "center" }
                          },
                          [
                            _c("small", { staticClass: "blue-grey--text" }, [
                              _vm._v("Date End")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._l(item.types, function(subItem, index) {
                      return _c(
                        "v-row",
                        {
                          key: index,
                          staticClass: "ma-0",
                          class:
                            index < item.types.length - 1 ? "border-bottom" : ""
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 py-0 border-right",
                              attrs: { cols: "3", align: "left" }
                            },
                            [
                              _c("small", { staticClass: "primary--text" }, [
                                _vm._v(
                                  _vm._s(subItem.stock.description || "N/A")
                                )
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 py-0 border-right",
                              attrs: { cols: "3", align: "left" }
                            },
                            [
                              _c(
                                "small",
                                { staticClass: "primary--text text-uppercase" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      subItem.feeding_program_category
                                        .description || "N/A"
                                    )
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 py-0 border-right",
                              attrs: { cols: "3", align: "right" }
                            },
                            [
                              _c("small", { staticClass: "primary--text" }, [
                                _vm._v(_vm._s(subItem.date_start.dateFormat()))
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 py-0",
                              attrs: { cols: "3", align: "right" }
                            },
                            [
                              _c("small", { staticClass: "primary--text" }, [
                                _vm._v(_vm._s(subItem.date_end.dateFormat()))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }